import { createContext, useContext } from "react";
import { ITypesCharacteristicsObjectContext } from "./types";

export const TypesCharacteristicsObjectContext = createContext<ITypesCharacteristicsObjectContext | null>(
  null
);

export const useTypesCharacteristicsObjectContext = () => {
  const context = useContext(TypesCharacteristicsObjectContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
